import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ onDone }) {
  const [count, setCount] = useState(0);
  const [gone, setGone] = useState(false);
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    const dur = 1500;
    const start = Date.now();
    const interval = setInterval(() => {
      const p = Math.min(1, (Date.now() - start) / dur);
      setCount(Math.floor(p * 100));
      if (p >= 1) clearInterval(interval);
    }, 50);
    // Guaranteed completion even if the counter interval is throttled/frozen
    const done = setTimeout(() => {
      setGone(true);
      doneRef.current && doneRef.current();
    }, dur + 300);
    return () => {
      clearInterval(interval);
      clearTimeout(done);
    };
  }, []);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          data-testid="site-loader"
          initial={{ y: 0 }}
          exit={{ y: "-101%" }}
          transition={{ duration: 1.1, ease: [0.85, 0, 0.15, 1] }}
          className="loader-mask"
        >
          <div className="font-mono-label text-xs opacity-70">
            DURU ÜNALAN · 2026 EDITION
          </div>
          <div className="flex items-baseline gap-4">
            <div className="display-sans text-6xl md:text-8xl">
              {String(count).padStart(3, "0")}
            </div>
            <div className="font-serif-editorial italic text-2xl md:text-3xl opacity-80">
              loading works&nbsp;&amp;&nbsp;words
            </div>
          </div>
          <div className="font-mono-label text-xs opacity-70 text-right">
            [ ANKARA / ISTANBUL ]
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
